'use client';

import PropTypes from 'prop-types';
import { pad, timeLeft, useNow } from '@/lib/homepage/useNow';

/**
 * When a competition closes. More than two days away it shows the day and
 * time; inside two days it counts down, and inside six hours it turns amber.
 * `label` is the server-formatted closing time, shown until the clock starts.
 */
export default function ClosesIn({ endDate, label, className = '' }) {
  const now = useNow();
  const t = timeLeft(endDate, now);

  if (!t || t.total > 48 * 3600 * 1000) {
    return <span className={className}>Closes {label}</span>;
  }
  if (t.total === 0) {
    return <span className={className}>Closed</span>;
  }

  const urgent = t.total <= 6 * 3600 * 1000;
  const clock = `${t.days > 0 ? `${t.days}d ` : ''}${pad(t.hours)}:${pad(t.minutes)}:${pad(t.seconds)}`;
  return (
    <span className={`${className} ${urgent ? 'text-warning' : ''}`}>
      Closes in <span className="tabular-nums font-bold">{clock}</span>
    </span>
  );
}

ClosesIn.propTypes = {
  endDate: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
};
